// fleet-generated: do not edit by hand
//
// Copied verbatim  : infra/fleet/artifacts/utils/uuid.ts
// Parameters       : none — below this header, identical across the fleet
// Destination      : packages/fleet/utils/src/uuid.ts
//
// TO CHANGE THIS FILE, edit the canonical copy in infra and re-render. It
// changes for the whole fleet at once. Editing it here is reverted by the
// next render, and the guard in this repo goes red in the meantime:
//
//     cd ../infra && node fleet/fleet.ts render --repo jornada-activity-app
//     node fleet/fleet.ts check --repo jornada-activity-app
//
// The generator runs LOCALLY and is never invoked by CI. CI only verifies
// that what is committed matches the hash in .github/fleet-lock.json, which
// also records WHICH infra commit produced it. The commit is deliberately
// not repeated here: one value, one place — and stamping it into every file
// meant a one-line template edit rewrote four files in 28 repos.
import { v7 as uuidv7 } from "uuid";

/**
 * Generates the ID of a stored row: a UUIDv7, so new rows land at the end of every
 * B-tree index instead of at random places (why, and the alternatives rejected:
 * infra/ID_FORMAT_UUIDV7.md). It starts with a millisecond timestamp, so it is NOT
 * a secret: anything that grants access when known uses generateSecretToken().
 */
export function generateId(): string {
  return uuidv7();
}

/**
 * Generates a value that grants access when known (share, invite or reset tokens):
 * 32 random bytes from the Web Crypto API, base64url without padding. A UUIDv7 has
 * only 74 random bits and reveals when it was made (ID_FORMAT_UUIDV7.md §4.2).
 */
export function generateSecretToken(): string {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  let binary = "";
  for (const b of bytes) {
    binary += String.fromCharCode(b);
  }
  return btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/, "");
}
